interface Number {
    formatMoney(): string;
}

Number.prototype.formatMoney = function (): string {
    try {
        const intVal = this;
        if (intVal == 0) return "0";
        return intVal.toFixed(2).replace(/\d(?=(\d{3})+\.)/g, '$&,').replace(/.00$/, "");
    } catch (error) {
        return "0";
    }
}